import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = { class: "space-y-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Patient Information", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Who is this appointment for?", -1)
const _hoisted_5 = {
  key: 0,
  class: "text-xs text-red-600"
}
const _hoisted_6 = {
  key: 0,
  class: "absolute w-5 h-5 bg-white rounded-full -top-2 -right-2"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "For Me", -1)
const _hoisted_8 = {
  key: 0,
  class: "absolute w-5 h-5 bg-white rounded-full -top-2 -right-2"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "For my dependent", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "py-2.5 space-y-2.5"
}
const _hoisted_12 = { class: "grid grid-cols-12 col-span-12 gap-6" }
const _hoisted_13 = { class: "col-span-6" }
const _hoisted_14 = { class: "col-span-6" }
const _hoisted_15 = { class: "col-span-6" }
const _hoisted_16 = { class: "col-span-6" }
const _hoisted_17 = { class: "col-span-6" }
const _hoisted_18 = { class: "col-span-6" }
const _hoisted_19 = { class: "col-span-6" }
const _hoisted_20 = { class: "col-span-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "Please answer the following questions:", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, "What is your relationship with this dependent?", -1)
const _hoisted_23 = { class: "grid grid-cols-2 gap-4 mt-2.5" }
const _hoisted_24 = { class: "border-b border-gray-50 pb-2.5" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, "Is this dependent a minor?", -1)
const _hoisted_26 = { class: "grid grid-cols-2 gap-4 mt-2.5" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-darkgray-400" }, "Note: Additional medical information about your dependent will be requested after you submit this booking request.")
], -1)

import { ref, watch} from 'vue';
import { CheckCircleIcon } from '@heroicons/vue/24/solid'
import RadioGroup from '@/components/inputs/RadioGroup.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import MobileNumber from "@/components/inputs/MobileNumber.vue";
import MultiselectInput from "@/components/inputs/MultiselectInput.vue";
import { useBookingStore } from '@/store/booking';


export default /*#__PURE__*/_defineComponent({
  __name: 'PatientInformation',
  props: {
    patient: {
        type: Object
    },
    error: {
        type: Boolean,
    }
},
  emits: ['selected-patient'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit;

const bookingStoreState = useBookingStore();


const selected = ref(null);
const dependentForm = ref(bookingStoreState.bookingPayload.dependent_patient);

const options = [
    {
        id: 1,
        value: 'child',
        label: 'My child',
    },
    {
        id: 2,
        value: 'spouse',
        label: 'My spouse',
    },
    {
        id: 3,
        value: 'parent',
        label: 'My parent',
    },
    {
        id: 4,
        value: 'others',
        label: 'Others',
    }
]
const minor_options = [
    {
        id: 1,
        value: true,
        label: 'Yes',
    },
    {
        id: 2,
        value: false,
        label: 'No',
    },
]

const sexes = [
    { id: '1', label: 'Male', value: 'Male' },
    { id: '2', label: 'Female', value: 'Female' },
    // { id: '3', label: 'Prefer not to Say', value: 'Prefer not to Say' },
];

const checkOption = () => {
    if(selected.value === 'dependent'){
        emit('selected-patient', {
            selected: selected.value,
            dependentForm: dependentForm.value
        });
    }
    else{
        emit('selected-patient',{
            selected: selected.value,
            dependentForm: null
        })
    }
}

watch([selected, dependentForm], () => {
    checkOption();
}, { deep: true });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (__props.error)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Please choose"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (selected.value = 'me')),
      class: _normalizeClass(["relative px-6 py-4 bg-white rounded-2xl", selected.value === 'me' ? 'outline outline-[3px] outline-primary-500 ' : ''])
    }, [
      (selected.value === 'me')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_unref(CheckCircleIcon), { class: "w-5 h-5 text-primary-500" })
          ]))
        : _createCommentVNode("", true),
      _hoisted_7
    ], 2),
    _createElementVNode("div", {
      onClick: _cache[11] || (_cache[11] = ($event: any) => (selected.value = 'dependent')),
      class: _normalizeClass(["relative px-6 py-4 bg-white rounded-2xl", selected.value === 'dependent' ? 'outline outline-[3px] outline-primary-500 ' : ''])
    }, [
      (selected.value === 'dependent')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_unref(CheckCircleIcon), { class: "w-5 h-5 text-primary-500" })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["", selected.value === 'dependent' ? 'pb-2.5 border-b border-gray-50' : ''])
      }, _hoisted_10, 2),
      (selected.value === 'dependent')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(TextInput, {
                  modelValue: dependentForm.value.first_name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dependentForm.value.first_name) = $event)),
                  id: "first_name",
                  name: "first_name",
                  label: "First Name",
                  placeholder: "First Name"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(TextInput, {
                  modelValue: dependentForm.value.middle_name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dependentForm.value.middle_name) = $event)),
                  id: "middle_name",
                  name: "middle_name",
                  label: "Middle Name",
                  placeholder: "Middle Name"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(TextInput, {
                  modelValue: dependentForm.value.last_name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dependentForm.value.last_name) = $event)),
                  id: "last_name",
                  name: "last_name",
                  label: "Last Name",
                  placeholder: "Last Name"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(MultiselectInput, {
                  modelValue: dependentForm.value.sex,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dependentForm.value.sex) = $event)),
                  id: "sex",
                  name: "sex",
                  label: "",
                  placeholder: "Sex",
                  options: sexes
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(DatePicker, {
                  modelValue: dependentForm.value.birthdate,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dependentForm.value.birthdate) = $event)),
                  id: "birthdate",
                  name: "birthdate",
                  label: "",
                  placeholder: "Birthday",
                  isTodayMaxDate: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(MobileNumber, {
                  modelValue: dependentForm.value.cellphone_number,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dependentForm.value.cellphone_number) = $event)),
                  id: "cellphone_number",
                  name: "cellphone_number",
                  label: "Mobile Number",
                  placeholder: "Mobile Number"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(TextInput, {
                  modelValue: dependentForm.value.telephone_number,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dependentForm.value.telephone_number) = $event)),
                  id: "telephone_number",
                  name: "telephone_number",
                  label: "Telephone Number",
                  placeholder: "Telephone Number"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(TextInput, {
                  modelValue: dependentForm.value.email_address,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dependentForm.value.email_address) = $event)),
                  id: "email_address",
                  name: "email_address",
                  label: "Email Address",
                  placeholder: "Email Address"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _hoisted_21,
            _createElementVNode("div", null, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _createVNode(RadioGroup, {
                  "label-class": "text-sm",
                  options: options,
                  modelValue: dependentForm.value.dependent_relationship,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dependentForm.value.dependent_relationship) = $event)),
                  name: "options"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createVNode(RadioGroup, {
                  "label-class": "text-sm",
                  options: minor_options,
                  modelValue: dependentForm.value.is_minor,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((dependentForm.value.is_minor) = $event)),
                  name: "minor-options"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _hoisted_27
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})